import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomBrandSafety = createSvgIcon(
  <path d="M16.104 9.129h-.684V7.774c0-1.87-1.532-3.387-3.42-3.387S8.58 5.904 8.58 7.774V9.13h-.684c-.752 0-1.368.61-1.368 1.355v6.774c0 .745.616 1.355 1.368 1.355h8.208c.752 0 1.367-.61 1.367-1.355v-6.774c0-.745-.615-1.355-1.367-1.355ZM12 15.226c-.752 0-1.368-.61-1.368-1.355s.616-1.355 1.368-1.355 1.368.61 1.368 1.355-.616 1.355-1.368 1.355M9.948 9.129V7.774A2.04 2.04 0 0 1 12 5.742a2.04 2.04 0 0 1 2.052 2.032V9.13H9.948Z" />,
  'CustomBrandSafety',
);

export default CustomBrandSafety;
